import Box from '@mui/material/Box';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { SegmentPartnerRevenueMethod } from '@openx/types/gqlTypes';
import { useMemo } from 'react';
import { formatNetFee } from './utils/formatters';
import { getPlatformFeeLabel } from './utils/labels';
import { calculateNetFee } from './utils/pricingCalculations';

type PlatformFeeDisplayProps = {
  pricingType: SegmentPartnerRevenueMethod;
  maxPrice: number;
  value: string;
  shouldShowNetFee?: boolean;
};

export const PlatformFeeDisplay = ({
  pricingType,
  maxPrice,
  value,
  shouldShowNetFee = true,
}: PlatformFeeDisplayProps) => {
  const isCpm = pricingType === SegmentPartnerRevenueMethod.Cpm;

  const netFee = useMemo(() => calculateNetFee(value, pricingType, maxPrice), [value, pricingType, maxPrice]);

  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        <Box
          sx={{
            flex: 1,
          }}
        >
          <FieldDetails title={getPlatformFeeLabel(pricingType)} value={value ? `${value}%` : '-'} />
        </Box>

        {shouldShowNetFee ? (
          <Box
            sx={{
              flex: 1,
            }}
          >
            <FieldDetails title="Net Fee" value={formatNetFee(netFee, isCpm)} />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};
